/**
 *
 * @param {Array} array1 Array with less or equal elements inside array2
 * @param {Array} array2 Object which contains all elements
 * @param {String} key1 common key of the objects present in both arrays if [key2]
 *                      is not provided. Otherwise represents the key of the objects
 *                      form [array1]
 * @returns an array of merged objects from both array based on the provided
 *          [key]
 */
function combineObjectsByKey(array1: any[], array2: any[], key1: string, key2?: string): any[] {
  return array1.map((obj1) => {
    const obj2 = array2.find((obj) => obj1[key1] === obj[key2 ?? key1]);
    return { ...obj1, ...obj2 };
  });
}

export default combineObjectsByKey;
